import _ from "lodash";

import { FunctionDefinition, SourceFunction } from "../functions/types";

export const SET_FUNCTIONS = "SET_FUNCTIONS";
export const UPSERT_FUNCTION = "UPSERT_FUNCTION";
export const DELETE_FUNCTION = "DELETE_FUNCTION";
export const UPSERT_SOURCE_FUNCTION = "UPSERT_SOURCE_FUNCTION";

export interface FunctionDefsState {
  functionDefs: FunctionDefinition[];
  sourceFunctions: SourceFunction[];
  isLoaded: boolean;
}

const defaultState: FunctionDefsState = {
  functionDefs: [],
  sourceFunctions: [],
  isLoaded: false,
};

function functionDefsReducer(
  state = defaultState,
  action: { type: string; payload: any }
): FunctionDefsState {
  switch (action.type) {
    case SET_FUNCTIONS:
      return {
        ...state,
        functionDefs: action.payload.function_defs,
        sourceFunctions: action.payload.source_functions,
        isLoaded: true,
      };
    case UPSERT_FUNCTION: {
      const index = state.functionDefs.findIndex(
        (functionDef) => functionDef.id === action.payload.id
      );
      const updatedFunctionDefs = [...state.functionDefs];
      if (index == -1) {
        updatedFunctionDefs.push(action.payload);
      } else {
        updatedFunctionDefs[index] = action.payload;
      }
      return { ...state, functionDefs: updatedFunctionDefs };
    }
    case DELETE_FUNCTION: {
      const index = state.functionDefs.findIndex(
        (functionDef) => functionDef.id === action.payload
      );

      const updatedFunctionDefs = [
        ...state.functionDefs.slice(0, index),
        ...state.functionDefs.slice(index + 1),
      ];

      return { ...state, functionDefs: updatedFunctionDefs };
    }
    case UPSERT_SOURCE_FUNCTION: {
      const index = state.sourceFunctions.findIndex(
        (sourceFunction) => sourceFunction.id === action.payload.id
      );
      const updatedSourceFunctions = [...state.sourceFunctions];
      if (index == -1) {
        updatedSourceFunctions.push(action.payload);
      } else {
        updatedSourceFunctions[index] = action.payload;
      }
      return { ...state, sourceFunctions: updatedSourceFunctions };
    }
    default:
      return state;
  }
}
export default functionDefsReducer;
